import { Checkbox, Menu } from '@cimplico/components';
import { Link } from 'react-router-dom';
import { useFirmContext } from '../../providers/FirmProvider';
import { useDismissNotifications } from '../../queries/use-dismiss-notifications';
import { useReadNotifications } from '../../queries/use-read-notifications';
import { UserNotification } from '../../types/notification';
import { calcRelativeTime } from '../../utilities/formatting';
import { NotificationIconType } from './NotificationIconType';

type NotificationRowProps = {
    userNotification: UserNotification;
    isFirst: boolean;
};

function NotificationRow({ userNotification, isFirst }: NotificationRowProps): JSX.Element {
    const { shortId } = useFirmContext();
    const dismissNotificationsQuery = useDismissNotifications();
    const readNotificationsQuery = useReadNotifications();

    function handleDismiss(): void {
        dismissNotificationsQuery.mutate({
            ids: userNotification.relatedNotifications ? userNotification.relatedNotifications : [userNotification.notification.id],
        });
    }

    function handleRead(): void {
        if (!userNotification.isRead) {
            readNotificationsQuery.mutate({
                ids: userNotification.relatedNotifications ? userNotification.relatedNotifications : [userNotification.notification.id],
            });
        }
    }

    const content = (
        <Menu.Button className="w-full flex gap-2 items-start text-xs" disabled={!userNotification.notification.destinationUrl}>
            <div className={`rounded-full mt-2.5 w-1 h-1 ${!userNotification.isRead ? 'border-blue-600 border-2 border-solid' : ''}`} />
            <div className="shrink-0">
                <NotificationIconType type={userNotification.notification.type} />
            </div>
            <div className="flex flex-col items-start text-gray-800 flex-wrap">
                <p className="font-medium text-left line-clamp-2">{userNotification.notification.message}</p>
                <p>{userNotification.notification.entity?.name}</p>
                <p className="text-gray-600">{userNotification.notification.workpaper?.name}</p>
            </div>
            <p className="text-gray-500 ml-auto text-right shrink-0">{calcRelativeTime(userNotification.notification.createdAt)}</p>
        </Menu.Button>
    );

    return (
        <div className="hover:bg-gray-200">
            <div className={`flex gap-4 p-2 w-[380px] mx-3 ${!isFirst ? 'border-t' : ''}`}>
                {userNotification.notification.destinationUrl ? (
                    <Link to={`/${shortId}${userNotification.notification.destinationUrl}`} className="w-full" onClick={handleRead}>
                        {content}
                    </Link>
                ) : (
                    <div className="w-full">{content}</div>
                )}
                <div className="ml-auto">
                    <Checkbox rounded onChange={handleDismiss} />
                </div>
            </div>
        </div>
    );
}

export default NotificationRow;
